<section class="content">
  <div class="card">
    <div class="card-body-placeholder">
      <img src="assets/images/icons/error.png" width="64"/>
      <h2 class="mt-5">Payment error</h2>
      <p class="my-3">Something went wrong. We couldn't proceed your payment.</p>
      <a class="btn btn-blue btn-blue-hover mt-5 px-5" routerLink="/payment/add">Try again</a>
    </div>
  </div>
</section>
